import React from 'react';
import ContentLoader from 'react-content-loader';

const DataTableLoader = (props) => (
  <ContentLoader
    speed={0.5}
    width={1500}
    height={400}
    viewBox="0 0 1500 400"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="10" y="20" rx="10" ry="10" width="169" height="19" />
    <rect x="200" y="20" rx="10" ry="10" width="169" height="19" />
    <rect x="400" y="20" rx="10" ry="10" width="169" height="19" />
    <rect x="600" y="20" rx="10" ry="10" width="169" height="19" />
    <rect x="800" y="20" rx="10" ry="10" width="85" height="19" />
    <rect x="900" y="20" rx="10" ry="10" width="85" height="19" />

    <rect x="10" y="50" rx="10" ry="10" width="169" height="19" />
    <rect x="200" y="50" rx="10" ry="10" width="169" height="19" />
    <rect x="400" y="50" rx="10" ry="10" width="169" height="19" />
    <rect x="600" y="50" rx="10" ry="10" width="169" height="19" />
    <rect x="800" y="50" rx="10" ry="10" width="85" height="19" />
    <rect x="900" y="50" rx="10" ry="10" width="85" height="19" />

    <rect x="10" y="80" rx="10" ry="10" width="169" height="19" />
    <rect x="200" y="80" rx="10" ry="10" width="169" height="19" />
    <rect x="400" y="80" rx="10" ry="10" width="169" height="19" />
    <rect x="600" y="80" rx="10" ry="10" width="169" height="19" />
    <rect x="800" y="80" rx="10" ry="10" width="85" height="19" />
    <rect x="900" y="80" rx="10" ry="10" width="85" height="19" />

    <rect x="10" y="110" rx="10" ry="10" width="169" height="19" />
    <rect x="200" y="110" rx="10" ry="10" width="169" height="19" />
    <rect x="400" y="110" rx="10" ry="10" width="169" height="19" />
    <rect x="600" y="110" rx="10" ry="10" width="169" height="19" />
    <rect x="800" y="110" rx="10" ry="10" width="85" height="19" />
    <rect x="900" y="110" rx="10" ry="10" width="85" height="19" />
    
  </ContentLoader>
);

DataTableLoader.metadata = {
  name: 'Mohd Arif Un',
  github: 'arif-un',
  description: 'Data Table skeleton',
  filename: 'DataTable',
};

export default DataTableLoader;
